var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 14.6654L11.1853 11.5117L14.3333 14.6654ZM12.9298 7.29694C12.9298 8.87894 12.3014 10.3961 11.1827 11.5148C10.0641 12.6334 8.54691 13.2619 6.96491 13.2619C5.38292 13.2619 3.86572 12.6334 2.74708 11.5148C1.62844 10.3961 1 8.87894 1 7.29694C1 5.71495 1.62844 4.19775 2.74708 3.07911C3.86572 1.96048 5.38292 1.33203 6.96491 1.33203C8.54691 1.33203 10.0641 1.96048 11.1827 3.07911C12.3014 4.19775 12.9298 5.71495 12.9298 7.29694V7.29694Z",
    stroke: "#BEBECE",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.71408f4c5915e0596b1216e91e1e50fe.svg";
export { ForwardRef as ReactComponent };